"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatText = void 0;

require("core-js/modules/es6.regexp.to-string");

var _predicate = require("../predicate");

var formatText = function formatText(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$nil = _ref.nil,
      nil = _ref$nil === void 0 ? '' : _ref$nil;

  return (0, _predicate.isNil)(value) ? nil : value.toString();
};

exports.formatText = formatText;